import AutoForm from "@virgodev/vue-models/components/forms/AutoForm.vue";
import { createStore } from "@virgodev/vue-models/utils/create_store";
import { defineStore } from "pinia";
import { computed, ref, shallowRef, watch, type Component } from "vue";
import { ManifestIndex, type LayoutCard } from "../utils/layout";
import defaultManifest from "../utils/manifests/default";

export const useUserLayoutStore = createStore<LayoutCard>("layout", "layouts");
export const useAdminLayoutStore = createStore<LayoutCard>(
  "admin_layout",
  "admin_layouts",
);

export const useLayoutStore = defineStore("layouts", () => {
  const timeouts = ref<Record<number, number>>({});
  const editing = ref(false);
  const manifest = shallowRef<ManifestIndex>(defaultManifest);
  const formBuilder = shallowRef<Component>(AutoForm);
  const userLayouts = useUserLayoutStore();
  const adminLayouts = useAdminLayoutStore();

  watch(editing, () => {
    sync();
  });

  const layouts = computed(() => {
    return editing.value ? adminLayouts : userLayouts;
  });

  const list = computed(() => {
    return layouts.value.list;
  });

  function sync() {
    return layouts.value.sync();
  }

  function save(item: LayoutCard) {
    layouts.value.save(item);
  }

  return {
    list,
    userLayouts,
    adminLayouts,
    editing,
    formBuilder,
    form: formBuilder,
    manifest,
    sync,
    save,
  };
});
